import { initAnalytics } from "@services/analytics";
import type { ReactNode } from "preact/compat";
import { useEffect } from "preact/hooks";

interface AnalyticsProviderProps {
  children: ReactNode;
}

export const AnalyticsProvider = ({ children }: AnalyticsProviderProps) => {
  useEffect(() => {
    initAnalytics();
  }, []);

  return children;
};
